import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';
import { getGroupScheduledFeed, fetchGroupFeedScheduled } from 'mewe/fetchers/fetch-feed';

export default Route.extend({
  theme: Theme.GROUP,

  id() {
    return this.modelFor('app.group').groupId;
  },

  model() {
    fetchGroupFeedScheduled(this.id(), { limit: 5 });

    return {
      app: this.modelFor('app'),
      feed: getGroupScheduledFeed(this.id()),
      groupModel: this.modelFor('app.group'),
    };
  },

  actions: {
    refreshFeed() {
      this.refresh();
    },
  },
});
